export const ABSOLUTE_ADJUSTMENT_FIELD_NAME = 'absoluteValue';
export const BASE_PRICE_FIELD_NAME = 'basePrice';
export const BASE_RATE_KEY_FIELD_NAME = 'baseRateKey';
export const DESCRIPTION_FIELD_NAME = 'description';
export const ENABLED_FIELD_NAME = 'isEnabled';
export const EXTERNAL_NAME_FIELD_NAME = 'externalName';
export const NAME_FIELD_NAME = 'name';
export const RATE_GROUP_KEY_FIELD_NAME = 'rateGroupKey';
export const RATE_KEY_FIELD_NAME = 'rateKey';
export const RATE_TYPE_FIELD_NAME = 'type';
export const RELATIVE_ADJUSTMENT_FIELD_NAME = 'relativeValue';
export const SHORT_NAME_FIELD_NAME = 'shortName';
export const IS_BONUS_POINTS_ELIGIBLE_FIELD_NAME = 'isBonusPointsEligible';
export const HIDE_PRICE_FROM_GUEST_FIELD_NAME = 'hidePriceFromGuest';
export const BUSINESS_SEGMENT_KEY_FIELD_NAME = 'businessSegmentKey';
export const ACCOUNTING_CATEGORY_KEY_FIELD_NAME = 'accountingCategoryKey';
export const EXTRA_OCCUPANCY_ADJUSTMENT_FIELD_NAME = 'extraOccupancyAdjustment';
export const NEGATIVE_OCCUPANCY_ADJUSTMENT_FIELD_NAME = 'negativeOccupancyAdjustment';
export const ORDERING_FIELD_NAME = 'ordering';
